import $ from 'jquery';
import * as CONST from '../../utils/constants';

const Tabs = CONST.globalProject.SelectedTabs;

class UpcomingMeetings {
    constructor() {
    }

    init() {
        this.cards = $('.content-item.has-cta');

        this.cards.each((index, card) => {
            $(card).on('click', (event) => {
                event.preventDefault();
                const href = $(card).data('url');
                if (href) {
                    window.location.href = href;
                }
            });
        });
    }
}

export default UpcomingMeetings;

$(() => {
    const upcomingMeetings = new UpcomingMeetings();
    setTimeout(() => { upcomingMeetings.init(); }, 500);
});